import { parsePhoneNumber } from 'awesome-phonenumber';

export { isValidEmail } from '@odo/shared-ui/utils/email';

const SUPPORTED_PHONE_REGIONS = ['US', 'CA'] as const;

/** Mirrors dashboard/src/utils/contact.ts - valid US or Canadian number. */
export const isValidPhone = (phone: string): boolean => {
    const digits = (phone || '').trim().replace(/\D/g, '');
    if (!digits) return false;
    return SUPPORTED_PHONE_REGIONS.some((r) => parsePhoneNumber(digits, { regionCode: r }).valid);
};

export const formatPhone = (phone: string, region: string = 'US'): string => {
    const parsed = parsePhoneNumber(phone, { regionCode: region });
    if (!parsed.valid) return phone;
    return parsed.number.national;
};

export const formatEmail = (email: string): string => {
    return email.trim().toLowerCase();
};
